module.exports = __webpack_public_path__ + "img/three-dot-icon.938eb463.svg";